import { AnalyticsFeatureViewed } from '@cc-shopping/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box, Stack, Typography, type TypographyProps } from '@mui/material';
import type { Odds } from '.';
import { ApprovalOddsButton } from './ApprovalOddsButton';
import { getApprovalLikelihoodLabel, getOddsLabel } from './utils';
export const ApprovalOddsLikelihoodContent = ({
  userCreditScore,
  odds,
  isAmexOffer,
  approvalLikelihood,
  typographyProps
}: {
  userCreditScore: number | undefined;
  approvalLikelihood: number | null | undefined;
  isAmexOffer: boolean;
  odds: Odds;
  typographyProps?: TypographyProps;
}) => {
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  const {
    min,
    max
  } = odds;
  if (!userCreditScore || !approvalLikelihood) {
    return <Box position="relative">
        <Box display="flex" sx={theme => ({
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column'
        }
      })}>
          {!isAmexOffer && <Typography>
              {min}-{max}
            </Typography>}
          <Typography marginLeft={1} sx={theme_0 => ({
          [theme_0.breakpoints.down('md')]: {
            marginLeft: 0
          }
        })}>
            {!isAmexOffer ? `(${getOddsLabel(min, max)})` : getOddsLabel(min, max)}
          </Typography>
        </Box>
        <ApprovalOddsButton />
      </Box>;
  }
  const label = getApprovalLikelihoodLabel(approvalLikelihood);
  return <AnalyticsFeatureViewed entityName="cc_approval_odds" entitySection={''} // It's ok that this is empty
  parentActivityId={skuImpressionId} impressionPosition={0} additionalAttributes={{
    approval_odds: label.toLowerCase()
  }}>
      <Stack direction="row" spacing={1}>
        <Typography sx={{
        display: 'inline',
        textTransform: 'capitalize'
      }} {...typographyProps}>
          {label}
        </Typography>
        <InfoTooltip ariaLabel="More information about your approval likelihood" text={<p>
              We think your odds of getting approved for this card are
              <strong> {label} </strong>
              based on your credit score and other factors. That said, these odds are an estimate to
              help you narrow your choices, not a guarantee. Card issuers may use different criteria
              than we do.
            </p>} />
      </Stack>
    </AnalyticsFeatureViewed>;
};